import { Flex, Select, Text } from "@radix-ui/themes";
import { locales, defaultLocale } from "@utils/i18n";
import { Trans } from "@lingui/macro";
import { usePersistentSurveyStore, useSurveyStore } from "@store/survey";
import { recordEvent } from "@api/survey";

export default function LanguageSelector() {
  const persistentSurveyStore = usePersistentSurveyStore();
  const language = persistentSurveyStore.getLanguage();
  const sessionUUID = useSurveyStore().sessionUUID;
  const currentSurveySection = useSurveyStore().currentSurveySection;

  function handleChange(locale) {
    persistentSurveyStore.setLanguage(locale);
    recordEvent({
      eventType: "selected_language",
      sessionUUID: sessionUUID,
      eventData: { selectedLanguage: language },
      surveySectionSlug: currentSurveySection,
    });
  }

  return (
    <Flex align="baseline" pt="1">
      <Text size="2" mr="2" color="gray">
        <Trans id="LanguageSelector.take_this_survey_in">
          View this page in
        </Trans>
      </Text>
      <Select.Root
        defaultValue={language || defaultLocale}
        onValueChange={handleChange}
        size="2"
      >
        <Select.Trigger variant="ghost" color="gray" />
        <Select.Content color="gray">
          <Select.Group>
            <Select.Label>
              <Trans id="LanguageSelector.language">Language</Trans>
            </Select.Label>
            {Object.entries(locales).map(([locale, label]) => (
              <Select.Item key={locale} value={locale}>
                <Text>{label}</Text>
              </Select.Item>
            ))}
          </Select.Group>
        </Select.Content>
      </Select.Root>
    </Flex>
  );
}
